"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = _interopRequireDefault(require("../style"));

var _createStyled = require("../../../utils/createStyled");

var PlainText = function PlainText(_ref) {
  var children = _ref.children,
      label = _ref.label,
      className = _ref.className,
      attribute = _ref.attribute,
      value = _ref.value,
      theme = _ref.theme,
      multiline = _ref.multiline;
  var styles = (0, _style["default"])(theme, {
    multiline: multiline
  });
  return _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.root,
    className: className
  }, label ? _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.label
  }, label) : null, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.field,
    "data-qa-node": attribute,
    "data-qa-value": value || ''
  }, value || children));
};

PlainText.defaultProps = {
  multiline: true
};
PlainText.propTypes = {
  attribute: _propTypes["default"].string,
  className: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].any,
  multiline: _propTypes["default"].bool,
  children: _propTypes["default"].any,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default inline-block
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.fontFamily
     */
    fontFamily: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.twNormal
     */
    fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 1.5
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter + 'px'
     */
    paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter + 'px'
     */
    paddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tLabel
     */
    labelColor: _propTypes["default"].string,

    /**
     * @default palette.tsXSmall
     */
    labelFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlXSmall
     */
    labelLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tError
     */
    errorLabelColor: _propTypes["default"].string,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
};
var _default = PlainText;
exports["default"] = _default;